import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FaxStatus } from "src/app/enums/fax-status";
import { IFax } from "src/app/models/fax/fax";
import { IFaxFolder } from "src/app/models/fax/fax-folder";

@Component({
  selector: "app-brief-fax-table",
  templateUrl: "./brief-fax-table.component.html",
  styleUrls: ["./brief-fax-table.component.scss"],
})
export class BriefFaxTableComponent {
  @Input() faxes: IFax[] = [];
  @Input() folders: IFaxFolder[] = [];
  @Input() placeholderText = "No faxes to display";
  @Input() isLoading = false;

  @Output() rowClick = new EventEmitter<number>();

  readonly skeletonRows = Array.from({ length: 5 });

  get doesFaxesExist() {
    return this.faxes?.length > 0;
  }

  getFolderName(folderId: number) {
    return this.folders.find(folder => folder.id === folderId)?.name ?? "-";
  }

  getStatusIconSrc(status: FaxStatus) {
    switch (status) {
      case FaxStatus.Success: {
        return "assets/img/icons/auth-success.svg";
      }
      case FaxStatus.Failed: {
        return "assets/img/icons/failed.svg";
      }
      default: {
        return "assets/img/icons/loading.svg";
      }
    }
  }

  splitDateTime(dateTime?: string) {
    if (!dateTime) {
      return [];
    }

    const date = new Date(dateTime);

    const datePart = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    const timePart = date.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });

    return [datePart, timePart];
  }
}
